(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('thirdPartyCtrl', ['$scope', '$sce', '$http', 'uteEndpoint', '$rootScope', '$stateParams', '$state', 'transactionHistoryService', 'uteLocale', function ($scope, $sce, $http, uteEndpoint, $rootScope, $stateParams, $state, transactionHistoryService, uteLocale) {
      $scope.noRecordFound = false;
      $scope.lang = uteLocale.language;
      if ($scope.lang == 'en') {
        if (!(_.isEmpty(transactionHistoryService.getResponse().en.thirdPartyTransactionHistory))) {
          $scope.noRecordFound = false;
          $scope.transactionResponse = transactionHistoryService.getResponse().en.thirdPartyTransactionHistory;
        } else {
          $scope.noRecordFound = true;
        }
      } else {
        if (!(_.isEmpty(transactionHistoryService.getResponse().fr.thirdPartyTransactionHistory))) {
          $scope.noRecordFound = false;
          $scope.transactionResponse = transactionHistoryService.getResponse().fr.thirdPartyTransactionHistory;
        } else {
          $scope.noRecordFound = true;
        }
      }
      if (!($scope.noRecordFound)) {
        $.each($scope.transactionResponse, function (key, value) {
          var date = new Date(value.date);
          value.date = date;
        })
      }
    }]);

})();
